import requests from "./httpService";

const AppointmentServices = {
  createAppointment(storeId, appointmentData) {
    return requests.post(
      `/api/stores/${storeId}/appointments`,
      appointmentData
    );
  },

  getAppointments(storeId, date) {
    const query = new URLSearchParams();
    if (date) {
      query.append("date", date);
    }
    const queryString = query.toString();
    const url = `/api/stores/${storeId}/appointments${
      queryString ? `?${queryString}` : ""
    }`;
    return requests.get(url).then((response) => {
      // Handle both old format (direct array) and new format (object with appointments property)
      if (response && response.appointments) {
        return response.appointments;
      }
      return response || [];
    });
  },

  getAppointment(storeId, appointmentId) {
    return requests.get(`/api/stores/${storeId}/appointments/${appointmentId}`);
  },

  updateAppointment(storeId, appointmentId, appointmentData) {
    return requests.put(
      `/api/stores/${storeId}/appointments/${appointmentId}`,
      appointmentData
    );
  },

  deleteAppointment(storeId, appointmentId) {
    return requests.delete(
      `/api/stores/${storeId}/appointments/${appointmentId}`
    );
  },
};

export default AppointmentServices;
